var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bto-sb-favorite",class:{ 'bto-sb-favorite-active': _vm.isFavorite() },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.changeFavorite()}}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }